<template>
  <div>
    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
      {{ title }}
    </label>
    <div class="w-full flex inline">
      <input autocomplete="off" :ref="reff" :class="{'bg-red-400 focus:bg-red-400' : !text && resend}"
        class="text-xs appearance-none block bg-gray-200 text-gray-700 border border-gray-200 w-full rounded px-4 leading-tight focus:outline-none focus:border-gray-500"
        v-model="text" type="text" placeholder="..." @input="listOptions()" @click="inputText()">
    </div>
    <!-- filteredOptions.length > 0: una tendina senza niente dentro non si apre
         proprio. Prima bastava cliccare nel campo perche' comparisse un riquadro
         bianco vuoto. Qui il filtro e' locale e sincrono, non c'e' nessuna attesa
         durante la quale la lista sia legittimamente vuota. -->
    <div v-show="showOptions && filteredOptions.length > 0" 
      class="origin-top-right absolute mt-2 overflow-scroll max-h-40 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
      role="menu" aria-orientation="vertical">
      <ul class="py-1 overflow-y-scroll">
        <li v-for="(option, index) in filteredOptions" :key="index" @click="selectOption(option)" class="px-3 py-2 cursor-pointer hover:bg-gray-200">
          {{ mapOptionTitle(option) }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    reff: String,
    mapOptionTitle: Function,
    title: String,
    options: Array,
    resend: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    },
    selectedOption: Object
  },
  data() {
    return {
      showOptions: false
    }
  },
  computed: {
      filteredOptions() {
        // Il confronto va fatto in maiuscolo DA TUTTE E DUE LE PARTI. Prima veniva
        // messo in maiuscolo solo quello che scrive l'utente: con una voce salvata
        // "Prova Srl" e la ricerca "prova", il confronto era
        //   "Prova Srl - ...".includes("PROVA")  ->  falso
        // e la rubrica non trovava niente. Nei ritiri non si vedeva perche' quelle
        // voci arrivano da AS400 gia' maiuscole; nella bollettazione le scrive il
        // cliente dal sito, come gli pare.
        const cerca = (this.text != null ? this.text : '').toUpperCase();
        const res = this.options.filter(
          o => (this.mapOptionTitle(o) || '').toUpperCase().includes(cerca));
        // Si ordina per lunghezza del TESTO mostrato: prima era x.length su un
        // oggetto, cioe' undefined, e il confronto dava NaN - non ordinava niente.
        res.sort((x, y) => (this.mapOptionTitle(x) || '').length - (this.mapOptionTitle(y) || '').length);
        return res;
      }
  },
  methods: {
    emitValues(text, option = undefined) {
      this.$emit('chosen', {
        text: text,
        selectedOption: option
      });
    },
    inputText() {
      this.showOptions = true;
    },
    listOptions() {
      this.emitValues(this.text);
      this.inputText();
    },
    selectOption(option) {
      this.showOptions = false;
      this.emitValues(this.mapOptionTitle(option), option);
    },
    close(e) {
      // Il click fuori chiude SEMPRE. Prima chiudeva solo se la lista aveva
      // qualcosa dentro (&& this.options.length > 0): con la rubrica vuota, o
      // senza voci che combaciano, il riquadro bianco restava aperto per sempre
      // e non c'era modo di mandarlo via. La chiusura non puo' dipendere da
      // cosa c'e' dentro la lista.
      if (!this.$el.contains(e.target)) {
        this.showOptions = false;
      }
    },
    cancel() {
      this.showOptions = false;
      this.emitValues('', undefined);
    }
  },
  mounted() {
    document.addEventListener('click', this.close);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.close);
  }
}
</script>